import {
  Badge,
  Box,
  Typography,
  useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { basicNavItems, getMenuItemIconConfig } from '../../../constants/navigationItems';
import NavigationItem from '../NavigationItem/NavigationItem';

type NavItem = {
  path: string;
  label: string;
  icon: JSX.Element;
  badge?: string;
};

const Navigation = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  // Use the same navigation items as BottomNavigator
  const navItems: NavItem[] = basicNavItems
    .filter((item) => !item.hidden && item.key !== 'addTransaction')
    .map((item) => {
      const iconConfig = getMenuItemIconConfig(item.key, theme);
      const IconComponent = iconConfig.component;

      return {
        path: item.path,
        label: t(item.translationKey, { ns: 'navigation' }),
        icon: <IconComponent {...iconConfig.props} sx={{ fontSize: 20, boxShadow: theme.shadows[6] }} />,
      };
    });

  return (
    <Box sx={{
      mt: 2,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Navigation Items */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {navItems
          .map((item: NavItem) => (
            <NavigationItem
              key={item.path}
              item={item}
              sx={{ position: 'relative' }}
            >
              {item.icon}
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {item.label}
              </Typography>
              {item.badge && (
                <Badge
                  sx={{
                    ml: 'auto',
                    '& .MuiBadge-badge': {
                      backgroundColor: theme.palette.success.main,
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '0.75rem',
                      minWidth: 20,
                      height: 20,
                      borderRadius: '50%',
                    }
                  }}
                  badgeContent={item.badge}
                />
              )}
            </NavigationItem>
          ))}
      </Box>
    </Box>
  );
};

export default Navigation; 